// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import UserSetupProductSetsState from "@store/Framework/Store/Store/Components/UserSetupProductSets/UserSetupProductSetsState";
import { Draft } from "immer";

const initialState: UserSetupProductSetsState = {
    setsIds: [],
};

const actions = {
    "Components/UserSetupProductSets/SelectActiveIds": (
        draft: Draft<UserSetupProductSetsState>,
        action: { setsIds: string[] },
    ) => {
        draft.setsIds = action.setsIds;
    },
};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type UserSetupProductSetsActions = Parameters<typeof reducer>[1];
export default reducer;
